/**
 * 掲示板 本文の AI 作文 hook。
 * 仕様書: docs/02_work/done/plan_board_feature.md §7-6
 *
 * composeBoardBody Callable を呼び、生成された本文（プレーンテキスト）を返す。
 * 添付 (PDF / 画像) は base64 でペイロードに含める（Callable の上限 ~10MB）。
 */
import { useMutation } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';

import { functions } from '@/lib/firebase';

export type BoardComposeKind = 'approval' | 'task' | 'report';

export interface ComposeBoardBodyInput {
  kind: BoardComposeKind;
  /** 編集中の本文（プレーンテキスト）。 */
  bodyText?: string;
  /** テキストエリアに貼り付けた素材。 */
  sourceText?: string;
  /** PDF / 画像。data は base64（データURLのプレフィックス無し）。 */
  attachments?: Array<{ mediaType: string; data: string }>;
}

const composeFn = httpsCallable<ComposeBoardBodyInput, { bodyText: string }>(
  functions,
  'composeBoardBody',
);

export function useComposeBoardBody() {
  return useMutation({
    mutationFn: async (input: ComposeBoardBodyInput) => {
      const res = await composeFn(input);
      return res.data;
    },
  });
}
